import { createStore } from "redux";
import Reducer from "./rudex/reducer/Reducer";


export const stor = createStore(Reducer);